import Chart from "chart.js";
import { Line, mixins } from "vue-chartjs";
import { generateChart } from "vue-chartjs";

const CustomLine = generateChart("custom-line", "LineWithLine");
const { reactiveProp } = mixins;

// 添加vertical line
Chart.defaults.LineWithLine = Chart.defaults.line;
Chart.controllers.LineWithLine = Chart.controllers.line.extend({
    draw: function(ease) {
        Chart.controllers.line.prototype.draw.call(this, ease);

        if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
            var activePoint = this.chart.tooltip._active[0],
                ctx = this.chart.ctx,
                x = activePoint.tooltipPosition().x,
                topY = this.chart.scales["y-axis-0"].top,
                bottomY = this.chart.scales["y-axis-0"].bottom;

            // draw line
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, topY);
            ctx.lineTo(x, bottomY);
            ctx.lineWidth = 2;
            ctx.strokeStyle = "#07C";
            ctx.stroke();
            ctx.restore();
        }
    }
});

Chart.Tooltip.positioners.custom = function(elements, position) {
    if (!elements.length) {
        return false;
    }
    let offset = 120;
    let offsetX =
        (elements[0]._chart.width * 3) / 4 > position.x ? offset : -offset;

    return {
        x: position.x + offsetX,
        y: position.y
    };
};

export default {
    // extends: Line,
    extends: CustomLine,
    mixins: [reactiveProp],
    props: ["options"],
    watch: {
        options: {
            handler: function(newChartOptions) {
                this.$data._chart.destroy();
                this.renderChart(this.chartData, newChartOptions);
            }
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options);
    }
};



// WEBPACK FOOTER //
// ./src/components/lineChart.js